<template>
    <div class="" style="background-image: url('/WholisticLife.jpg')">
        <div class="uk-padding-large" style="background-color: rgba(251, 251, 251, 0.9)">
            <div class="uk-container">
                <h3 class="uk-text-center uk-text-bold">Additional Information for Admission</h3>
                <p class="uk-text-small uk-text-center ">
                    This is supplementary information for applicants to assist in making their decision for NCU..
                </p>

                <div class="uk-text-center">
                    <router-link to="/transfer_students" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> Transfer Students</router-link>
                    <router-link to="/international_students" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> International Students</router-link>
                    <router-link to="/provisional_acceptance" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> Provisional Acceptance</router-link>

                </div>
                <!--<br>
                <div class="uk-text-center">
                    <a href="#" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> Mature Age Examination (MAE)</a>
                    <a href="#" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> Special Students</a>
                    <a href="#" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> Pre-University</a>

                </div>-->


               <!-- <div class="uk-text-center">
                    <a href="#" class="uk-button uk-button-default uk-margin-right " style="border: 1px solid silver;">Learn More  <span style="margin-top: -2px" uk-icon="chevron-right"></span></a>
                </div>-->

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "additionalUndergradInformation"
    }
</script>

<style scoped>
    .yellow{
        border-bottom: 1px solid gold;
        font-size: large;
        color: #033860;
        font-weight: bold;
    }
    @media screen and (max-width:600px){


        h3,.uk-text-capitalize{
            font-size: 1.1em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
